import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 50px 80px;
  min-height: 70vh;
  text-align: center;
`;

const NotFoundTitle = styled.h1`
  font-size: 5rem;
  margin-bottom: 20px;
`;

const NotFoundDescription = styled.p`
  font-size: 1.2rem;
  margin-bottom: 30px;
  max-width: 600px;
`;

const HomeButton = styled(Link)`
  display: inline-block;
  padding: 12px 24px;
  background-color: #000;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #333;
  }
`;

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Dogukan Yaylaci</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="The page you're looking for doesn't exist or has been moved." />
      </Helmet>
      
      <NotFoundContainer>
        <NotFoundTitle>404</NotFoundTitle>
        <NotFoundDescription>
          Oops! The page you're looking for doesn't exist or has been moved.
        </NotFoundDescription>
        <HomeButton to="/">Back to Home</HomeButton>
      </NotFoundContainer>
    </>
  );
};

export default NotFoundPage; 